import * as comparatorUtilities from  "../../utility/comparator";
import { savePriceSummaryLinkInformation } from '../../utility/comparator';

export default ngModule => {

    ngModule.controller('OperatorStep2Ctrl', function (
        AonApi,
        AonApplicationService,
        AonConfig,
        AonProducts,
        application,
        matchmedia,
        OperatorService,
        services,
        $scope,
        $state,
        $stateParams,
        $window,
        ZohoService) {

        this.corporate = AonConfig.corporate;
        this.formChoices= AonConfig.formChoices;
        this.paymentFrequencies = AonConfig.jsConstants.PaymentFrequencies;
        this.isLoadingResults = false;
        this.debugOverlay = AonApplicationService.isDebug();
        this.services = services;

        this.getPricing = $scope.$parent.ctrl.getPricing;
        this.currentPrice = $scope.$parent.ctrl.currentPrice;
        this.currentPriceForDD = $scope.$parent.ctrl.currentPriceForDD;
        this.futurePrice = $scope.$parent.ctrl.futurePrice;
        this.futurePriceDifference = $scope.$parent.ctrl.futurePriceDifference;
        this.paymentFrequencyLabel = $scope.$parent.ctrl.paymentFrequencyLabel;

        this.operatorFilterControl = OperatorService.controls;
        this.operatorFilters = OperatorService.filters;
        this.paymentFrequencyChoices = OperatorService.paymentFrequencyChoices();
        this.hasDefaultDiscount = OperatorService.hasDefaultDiscount();
        this.operatorFilters.offset = 0;
        this.detailsPaneOpen = true;

        this.showDirectDebitDiscountLines = this.formChoices.direct_debit_discount_available;

        // Based on configuration, optionally show a link next to each price
        // that opens a new tab and fetches a detailed summary of the pricing for
        // a given price id. We store the applicant data into local storage and
        // retrieve it in the price summary controller.
        this.showPriceSummaryLink = AonConfig.deployment.show_price_summary_link;
        if (this.showPriceSummaryLink) {
            savePriceSummaryLinkInformation(application);
        }
        this.generatePriceSummaryLink = (priceId) => {
            return `${window.location.pathname}#/price-summary/${priceId}`;
        };

        const generateCompareLink = () => {
            const previous_fund = _.get(this.applicant, 'personal.previous_fund', {});
            const comparison_product = _.get(this.applicant, 'comparison_product', {});
            const args = [
                previous_fund.hospital_product ? `current-hospital=${previous_fund.hospital_product.id}` : null,
                previous_fund.ancillary_product ? `current-ancillary=${previous_fund.ancillary_product.id}` : null,
                comparison_product.hospital_product ? `new-hospital=${comparison_product.hospital_product.id}` : null,
                comparison_product.ancillary_product ? `new-ancillary=${comparison_product.ancillary_product.id}` : null,
            ].filter(Boolean).join('&');
            return `/api/compare-product-services?${args}`;
        };

        const resetScrollPosition = () => {
            $scope.$parent.ctrl.scrollToId(['active-quote-banner', 'ui-view']);
        }

        window.scrollTo(0, 0);
        resetScrollPosition();

        this.hasActiveQuote = () => _.get(this.applicant, 'zoho.has_quote');

        const priceIsQuotedPrice = (price) => {
            const rateCode = _.get(this.applicant, 'zoho.rate_code');
            return rateCode === String(price.id);
        };

        this.refine = (leavePaneOpen = false) => {
            const excess_field = 'excess';

            const [ancillary, hospital] = [
                _.filter(services.ancillary, 'selected'),
                _.filter(services.hospital, 'selected')
            ];

            this.isLoadingResults = true;
            const success = response => {
                const hasQuote = this.hasActiveQuote();
                let rebatePercentage = comparatorUtilities.calcRebate(this.applicant, AonApplicationService);
                let healthCoverLoading = comparatorUtilities.calcLHC(this.applicant, AonApplicationService);
                this.applicant.policy.healthCoverLoading = healthCoverLoading;
                this.applicant.policy.rebatePercentage = response.data.applicant.rebate_percent;
                const packages = response.data.packages,
                    // Get max number of excess options for a package
                    maxExcessCount = _(packages).pluck('prices').map('length').max();
                this.responsive = packages.length < 4;

                // Map over each package to perform price calculations, sort prices, format excess, etc.
                this.packages = _.map(response.data.packages, (pricePackage) => {

                    pricePackage.prices = _.map(pricePackage.prices, p => {
                        p[excess_field] = p[excess_field].split(".")[0];
                        p.phioUrls = p.phio_product_sheet_links;
                        return p;
                    });
                    if (pricePackage.fund.code === 'ahb') {
                        // Sort by fund product code, then excess
                        let codeMap = { C: 'a', R: 'b', A: 'c'};
                        pricePackage.prices = pricePackage.prices.sort((a, b) => {
                            let stringComp = codeMap[a.fund_product_code.slice(-1)].localeCompare(codeMap[b.fund_product_code.slice(-1)]);
                            if (stringComp != 0) {
                                return stringComp;
                            } else {
                                return b[excess_field] - a[excess_field];
                            }
                        });
                    } else {
                        pricePackage.prices = pricePackage.prices.sort((a, b) => b[excess_field] - a[excess_field]);
                    }

                    comparatorUtilities.applyDirectDebitDiscount(pricePackage);
                    comparatorUtilities.priceCalculations(
                        pricePackage,
                        rebatePercentage,
                        healthCoverLoading,
                        this.operatorFilters.payment_frequency
                    );

                    // If a $500 excess product is available, select it as the default
                    const excess_500_index = pricePackage.prices.findIndex(price => price[excess_field] == 500);
                    const defaultSelectedPriceIndex = excess_500_index > -1 ? excess_500_index : 0;
                    pricePackage.selectedPrice = pricePackage.prices[defaultSelectedPriceIndex];

                    // If the applicant has an active quote, and it is in this package, select it
                    if (hasQuote) {
                        const quotedPriceIndex = pricePackage.prices.findIndex(priceIsQuotedPrice);
                        if (quotedPriceIndex > -1) {
                             pricePackage.selectedPrice = pricePackage.prices[quotedPriceIndex];
                        }
                    }

                    pricePackage.features = {
                        hospital: comparatorUtilities.getProductFeatures(
                            pricePackage,
                            this.services.hospital,
                            pricePackage.hospital_product.product_hospital_services),
                        ancillary: comparatorUtilities.getProductFeatures(
                            pricePackage,
                            this.services.ancillary,
                            pricePackage.ancillary_product.product_ancillary_services),
                    };
                    pricePackage.showUnselectedServices = {
                        hospital: false,
                        ancillary: false
                    };

                    // Calculate how many prices this package is short by. This is purely so we can add empty dom elements
                    // so that heights match up across columns in the HTML. Not very elegant, but easiest solution while
                    // maintaining responsive flow of columns.
                    const shortBy = maxExcessCount - pricePackage.prices.length;
                    if (shortBy > 0) {
                        pricePackage.fillerPrices = _.range(0, shortBy)
                    }
                    return pricePackage
                });

                // Build a list of applicable fund-level offers
                let offered_funds = _.map(packages, p => p.fund.id);
                this.fund_offers = _.filter(
                    this.corporate.fund_offers,
                        o => (o.cover == this.applicant.policy.cover_type ||
                    o.cover == -1) && _.contains(offered_funds, o.fund_id)
                );
                this.fund_offers = _.map(this.fund_offers, o => ({
                    fund_name: o.fund_name,
                    offer: o.offer,
                }));

            }, error = err => {
                console.log(err);
            }, fin = () => {
                this.isLoadingResults = false;
                resetScrollPosition();
            }

            AonApplicationService.getApplication().then(applicant => {
                const applicantData = comparatorUtilities.applicantWithDOB(applicant);

                AonProducts.searchPackages(applicantData, {
                    hospital,
                    ancillary,
                }, this.operatorFilters).then(success, error)['finally'](fin);
            });
        };

        this.toggleUnselectedServiceSummary = (pkg, type) => {
            if (matchmedia.isPhone()) {
                pkg.showUnselectedServices[type] = !pkg.showUnselectedServices[type];
            } else {
                const status = !pkg.showUnselectedServices[type];
                for (let p of this.packages) {
                    p.showUnselectedServices[type] = status;
                }
            }
        };

        this.checkedPrices = {};
        this.checkPriceLoading = {};
        /**
         * Check prices with the fund
         * @param pkg
         */
        this.checkPrice = (pkg) => {
            const applicant = this.applicant;
            const price = pkg.selectedPrice;
            this.checkPriceLoading[pkg.id] = true;
            AonApi.post(`funds/${pkg.fund.id}/pricecheck`, {applicant, price}).then(result => {
                this.checkedPricesProduct = price;
                this.checkedPrices = _.assign(this.checkedPrices, result.data);
                $('#check-price.modal').modal();
            })['finally'](() => this.checkPriceLoading[pkg.id] = false);
        }

        const isRetention = (fund) => {
            if (!fund || !fund.code) {
                return false;
            }
            if (!_.get(this.applicant, 'personal.previous_fund.has_previous_fund', false)) {
                return false;
            }
            return _.get(this.applicant, 'personal.previous_fund.fund_id', '').toLowerCase() === fund.code.toLowerCase();
        }

        const saveQuoteAndContinue = (saleType, nextUrl) => {
            // If we have a Zoho id, update applicant record in Zoho when operator clicks 'Apply'
            if (this.applicant.zoho_id) {
                try {
                    // Don't wait for this to finish or anything, just fire off the save quote and carry on
                    this.saveZohoQuote();
                } catch (error) {
                    console.warn('Error saving quote - ', error);
                }
            }
            AonApplicationService.getApplication().then(applicant => {
                _.set(applicant, 'sale.type', saleType);
                AonApplicationService.saveApplication(applicant);
                $state.transitionTo(nextUrl);
            });
        }

        this.apply = (price, pkg) => {
            AonApplicationService.setProduct(pkg);
            AonApplicationService.setPrice(price);
            const applicationLink = _.get(this.applicant, 'quote_details.application_link')
            if (
                applicationLink &&
                !applicationLink.split('://')[1].startsWith(window.location.hostname)
            ) {
                window.open(
                  applicationLink,
                  '_blank'
                );
            } else {
                const code = price.fund.code.split('.')[0];
                saveQuoteAndContinue('distribution', `comparator.step3.${code}`);
            }
        };

        AonApplicationService.getApplication().then(applicant => {
            this.applicant = applicant;
            if (this.corporate.is_service_comparison_tool) {
                this.serviceComparisonLink = generateCompareLink();
            }

            this.refine(true);
        });

        this.countServices = (pkg) => {
            let n_ancillary = pkg.ancillary_product.product_ancillary_services ? pkg.ancillary_product.product_ancillary_services.length : 0;
            let n_hospital = pkg.hospital_product.product_hospital_services ? pkg.hospital_product.product_hospital_services.filter( e => !e.excluded ).length : 0;
            return {
                ancillary: n_ancillary,
                hospital: n_hospital,
            }
        };

        this.limitTotals = (pkg) => {
            const limits = pkg.selectedPrice.productpriceancillaryservicelimit_set;
            const groups = {};
            for (let i = 0; i < limits.length; i++) {
                groups[limits[i].limit_group] = limits[i];
            }
            let totals = { person: 0, policy: 0, service: 0 };
            for (let key of Object.keys(groups)) {
                totals.person += groups[key].limit_per_person ? parseFloat(groups[key].limit_per_person) : 0;
                totals.policy += groups[key].limit_per_policy ? parseFloat(groups[key].limit_per_policy) : 0;
                totals.service += groups[key].limit_per_service ? parseFloat(groups[key].limit_per_service) : 0;
            }
            return totals;
        };

        this.toggleFundFilterOpen = () => {
            this.operatorFilterControl.showFundFilter = !this.operatorFilterControl.showFundFilter;
        }

        this.toggleFundFilterOpenNonPanel = () => {
            this.operatorFilterControl.showFundFilterNonPanel = !this.operatorFilterControl.showFundFilterNonPanel;
        }

        this.toggleFundFilterAll = () => {
            this.operatorFilters.funds = this.operatorFilters.funds.map( f => {
                f.selected = this.operatorFilterControl.allFundsSelected;
                return f;
            });
        };

        this.toggleFundFilterAllNonPanel = () => {
            this.operatorFilters.non_panel_funds = this.operatorFilters.non_panel_funds.map( f => {
                f.selected = this.operatorFilterControl.allFundsSelectedNonPanel;
                return f;
            })
        };

        this.toggleAllTierFilter = () => {
            this.operatorFilters.hospital_classifications = this.operatorFilters.hospital_classifications.map(
              classification => {
                classification.selected = this.operatorFilterControl.allTiersSelected;
                return classification;
            })
        };

        this.showHospitalTiersFilter = () => {
          return (
            this.formChoices.hospital_classification_filter_options &&
            this.applicant.requiresHospitalProducts()
          );
        }

        this.emailQuote = function (form) {
            if (!form.$valid) {
                return;
            }
        };

        this.updatePriceCalculations = (pkg, paymentFrequency) => {
            let rebatePercentage = comparatorUtilities.calcRebate(this.applicant, AonApplicationService);
            let healthCoverLoading = comparatorUtilities.calcLHC(this.applicant, AonApplicationService);
            comparatorUtilities.priceCalculations(pkg, rebatePercentage, healthCoverLoading, paymentFrequency);
        };

        this.onSaveZohoQuote = (pkg) => {
            AonApplicationService.setProduct(pkg);
            this.saveZohoQuote({
                    sendEmail: false,
                    sendSMS: false,
                },!AonConfig.corporate.disable_save_quote_workflow);
        };

        this.onCloseSaveQuote = () => {
            this.saveQuoteVisible = false;
        };

        this.saveZohoQuote = (form = {},showQuoteWorkflow = false) => {
            AonApplicationService.getApplication().then(applicant => {
                this.saveQuoteVisible = showQuoteWorkflow;
                const {
                    sendEmail,
                    sendSMS,
                    expectedYearlySavings,
                    improvedBenefit1,
                    improvedBenefit2,
                    improvedBenefit3,
                } = form;
                const pkg = AonApplicationService.getProduct(false);
                const applicantData = comparatorUtilities.applicantWithDOB(applicant);
                applicantData.zoho = {
                    send_email: !!sendEmail,
                    send_sms: !!sendSMS,
                    expected_yearly_savings: parseInt(expectedYearlySavings),
                    improved_benefit_1: improvedBenefit1,
                    improved_benefit_2: improvedBenefit2,
                    improved_benefit_3: improvedBenefit3,
                };
                pkg.isSavingZohoQuote = true;
                const suppressOpportunityNote = Object.keys(form).length === 0;
                ZohoService.sendQuoteToZoho(applicant.zoho_id, applicantData, pkg, suppressOpportunityNote)
                    .then((response) => {
                        const {applicant} = response.data;
                        pkg.saveZohoQuoteFailed = false;
                        this.applicant.zoho = applicant.zoho;
                        this.applicant.quote_details = applicant.quote_details
                        AonApplicationService.saveApplication(applicant);
                    })
                    .catch(() => {
                        pkg.saveZohoQuoteFailed = true;
                    })
                    .finally(() => {
                        pkg.isSavingZohoQuote = false;
                    });
            });
        };

        this.defenceLabel = (code) => {
            switch (code.slice(-1)) {
                case 'C': return 'All';
                case 'A': return 'Permanent';
                case 'R': return 'Reserve';
            }
        };

        this.prevResultPage = () => {
            this.operatorFilters.offset -= 1;
            if (this.operatorFilters.offset < 0) {
                this.operatorFilters.offset = 0;
            }
            this.refine();
        };

        this.nextResultPage = () => {
            this.operatorFilters.offset += 1;
            this.refine();
        };

        this.filterUpdate = (clear_offset) => {
            if (clear_offset) {
                this.operatorFilters.offset = 0;
            }
            OperatorService.updateDiscountDependantFilters();
            setTimeout(this.refine, 0);
        };

        this.discounts = (pkg) => {
            const pricing = this.getPricing(pkg, 'available', pkg.apply_direct_debit_discount, false);
            return pricing ? pricing.discounts : [];
        };

        this.isProductClosed = price => price.product_status === AonConfig.jsConstants.ProductPriceStatus.CLOSED;

        this.previousProductDisplay = product =>
          `${product.name}${product.monthly_premium ? ` (Premium: $${product.monthly_premium}, Excess: $${Math.round(product.excess)}, ${product.product_status})` : ''}`;

        this.fundGeneralOffer = fundCode => this.corporate.general_offers[fundCode];

        this.showServiceFilters = () => {
            // We clone the service filters here so that we only apply the new filters if the
            // user clicks the 'Apply' button
            this.application = application;
            this.serviceFilters = _.cloneDeep(services);
            this.servicesInColumns = comparatorUtilities.splitServicesIntoColumns(this.serviceFilters);
            $('#service-filters.modal').modal();
        };

        this.applyServiceFilters = () => {
            const updateServices = key => this.services[key].forEach((service, index) => {
                service.selected = this.serviceFilters[key][index].selected;
            })
            updateServices('hospital');
            updateServices('ancillary');
            if (this.application.zoho_id) {
                const selectedServices = services => services.filter(s => s.selected).map(s => s.id);
                ZohoService.saveServicesToZoho(this.application.zoho_id, {
                    hospital: selectedServices(this.services.hospital),
                    ancillary: selectedServices(this.services.ancillary),
                });
            }
            this.refine();
        };

        this.toggleDetailsPane = () => {
            this.detailsPaneOpen = !this.detailsPaneOpen;
        };

        this.canApply = (pkg) => {
            if (this.corporate.disable_apply_button) {
                return false;
            }
            const { RetentionProcessingLookup } = AonConfig.jsConstants;
            const { allow_retention_processing } = AonConfig.corporate;
            const retentionApplicationNotAllowed = (
              allow_retention_processing !== RetentionProcessingLookup.APPLICATION
            );
            if (isRetention(pkg.fund) && retentionApplicationNotAllowed && !AonConfig.corporate.enable_member_transfers) {
                return false;
            }
            if (this.applicant.zoho_id) {
                return this.hasActiveQuote() && priceIsQuotedPrice(pkg.selectedPrice);
            }
            return true;
        };

        this.canSaveQuote = (pkg) => {
            if (this.corporate.disable_apply_button) {
                return false;
            }
            if (!this.applicant.zoho_id) {
                return false;
            }
            const { RetentionProcessingLookup } = AonConfig.jsConstants;
            const { allow_retention_processing } = AonConfig.corporate;
            const retentionSaveQuoteNotAllowed = (
              allow_retention_processing === RetentionProcessingLookup.DISALLOW
            );
            if (isRetention(pkg.fund) && retentionSaveQuoteNotAllowed && !AonConfig.corporate.enable_member_transfers) {
                return false;
            }
            return true;
        };

        // Return the css class for a column, based on price package in that column
        this.columnClass = (pkg) => ({
            'current-policy': pkg.is_current_policy,
        });

        /**
         * Whether to show a warning/notice about the price being calculated from a monthly price
         * @param pkg The price package to check
         * @param which 'future' or 'available'
         */
        this.showPaymentFrequencyEstimatedNotice = (pkg, which) => {
            if (this.operatorFilters.payment_frequency === 'fortnightly') {
                return pkg.selectedPrice.pricing[which].fortnightly_price_calculated;
            }
            return this.operatorFilters.payment_frequency !== 'monthly';
        };
    });
}



// WEBPACK FOOTER //
// ./src/controllers/comparator/operator-step2-ctrl.js